import $ from 'jquery';
// slick is loaded from the CDN in _Layout <head> and registers on the global jQuery (which the bundle
// also uses via webpack externals) — bundling a second copy added 87KB for nothing.

export default function initSimilarProductsCarousel():void {
    $('.similar-products-slick-init').slick({
        dots: true,
        infinite: true,
        speed: 300,
        slidesToShow: 4,
        slidesToScroll: 4,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                    infinite: true,
                    dots: true
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    });
}
